import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  loader: {
    height: "60vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  topSectionLeft: {
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    display: "flex",
    justifyContent: "space-even",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.typography.pxToRem(20),
    paddingTop: "10px",
  },
}));

export default useStyles;
